import React, { useState, useEffect, useRef } from "react";
import { Button, ConfirmDialog, Dialog, InputText, Toast } from "primereact";

import AutoCompleteDropdown from "../../../../Components/Form/AutoCompleteDropdown";
import { useForm } from "../../../../Hooks/useForm";
import { toastShow } from "../../../../Services/ToastService";
import Loader from "../../../../Components/Loader/Loader";
import { getAreas } from "../../../../../API/Global/Areas/AreasRequests";
import { guardarRuta, editarRuta } from "../../../../../API/IT/Rutas/RutasRouter";
import { getMarcas } from "../../../../../API/IT/MarcaProducto/MarcaProductoRequest";
import { getEstadosFabrics } from "../../../../../API/Global/Status/StatusRequests";
import { InputTextarea } from "primereact/inputtextarea";

const RutasCRUD = ({
  listRutas,
  ruta,
  rutaDialog,
  setRutaDialog,
  toastRef,
  getPos,
  modo,
}) => {

  const [show, setShow] = useState(false);
  const [areas, setAreas] = useState([]);
  const [marcas, setMarcas] = useState([]);
  const [estados, setEstados] = useState([]);

  const [loading, setLoading] = useState(false);

  const initialValues = {
    IdRouter: -1,
    IP: "",
    SSID: "",
    ClaveSSID: "",
    ClaveRouter: "",
    IdMarca: ruta ? ruta?.IdMarca : "",
    Modelo: "",
    Serie: "",
    IdArea: ruta ? ruta?.IdArea : "",
    Ubicacion: "",
    IdEstado: modo === "Crear" ? 3480 : ruta ? ruta.IdEstado : ""
  };

  const { values, handleInputChange, setValues, resetForm, error, setError } =
    useForm(initialValues);

  const getValoresIniciales = async () => {
    setLoading(true);

    const area = await getAreas();
    setAreas(area);

    const marca = await getMarcas();
    setMarcas(marca);

    const estado = await getEstadosFabrics();
    setEstados(estado);

    const areaInicial = modo === "Crear" ? "" : area.find((a) => a.IdArea === ruta?.IdArea);
    const marcaInicial = modo === "Crear" ? "" : marca.find((m) => m.IdMarca === ruta?.IdMarca);
    const estadoInicial = modo === "Crear" ? estado[0] : estado?.find((s) => s.IdStatus === values?.IdEstado);
    
    setValues({
      ...ruta,
      IP: ruta?.IP,
      SSID: ruta?.SSID,
      ClaveSSID: ruta?.ClaveSSID,
      ClaveRouter: ruta?.ClaveRouter,
      Marca: ruta?.Marca,
      Modelo: ruta?.Modelo,
      Serie: ruta?.Serie,
      Areas: areaInicial,
      Ubicacion: ruta?.Ubicacion,
      Marcas: marcaInicial,
      Estados: estadoInicial
    });

    setLoading(false);
  };

  const verificarInfo = () => {
    let error = {};
    if (!values.IP) {
      error.IP = true;
      error.error = true;
    }
    if (!values.SSID) {
      error.SSID = true;
      error.error = true;
    }

    if (!values.ClaveSSID) {
      error.ClaveSSID = true;
      error.error = true;
    }

    if (!values.ClaveRouter) {
      error.ClaveRouter = true;
      error.error = true;
    }

    if (!values.Areas || !values.Areas.IdArea) {
      error.IdArea = true;
      error.error = true;
    }

    if (!values.Estados || !values.Estados.IdStatus) {
      error.IdStatus = true;
      error.error = true;
    }
    setError(error);
    return error;
  };

  const verificarDuplicado = () => {
    const duplicado = listRutas.find(
      (r) => r.IdRouter !== values.IdRouter && r.IP === values.IP
    );

    if (duplicado) {
      let mensaje = "Ya existe una ruta con el mismo valor de: ";
      if (duplicado.IP === values.IP) mensaje += `IP ${duplicado.IP}`;
      return mensaje;
    }

    return null;
  };

  const agregarRuta = async () => {
    const e = verificarInfo();

    if (e.error) {
      toastShow(toastRef, "error", "Error", "Campos requeridos, IP, SSID, Clave SSID, Clave Router y Area");
      return;
    }

    if (!e.error) {
      const duplicado = verificarDuplicado();

      if (duplicado) {
        toastShow(toastRef, "error", "Error", duplicado);
        return;
      }

      let areaID = null;
      if (values.Areas) {
        areaID = values.Areas.IdArea;
      }

      const a = {
        IdRouter: values.IdRouter,
        IP: values.IP,
        SSID: values.SSID,
        ClaveSSID: values.ClaveSSID,
        ClaveRouter: values.ClaveRouter,
        IdMarca: values.Marcas.IdMarca,
        Modelo: values.Modelo,
        Serie: values.Serie,
        IdArea: areaID,
        Ubicacion: values.Ubicacion,
        IdEstado: values.Estados.IdStatus
      };

      if (a.IdRouter > 0) {
        setLoading(true);
        const resultado = await editarRuta(a);
        if (resultado[0]?.ESTADO === 1) {
          toastShow(
            toastRef,
            "success",
            "Datos Editados",
            resultado[0]?.MENSAJE
          );
          getPos();
          setTimeout(() => {
            onHide();
            setLoading(false);
          }, 1300);
        } else {
          toastShow(toastRef, "error", "Error", resultado[0]?.MENSAJE);
        }
      } else {
        const resultado = await guardarRuta(a);
        if (resultado[0]?.ESTADO === 1) {
          toastShow(
            toastRef,
            "success",
            "Datos Agregados",
            resultado[0]?.MENSAJE
          );
          getPos();
          setTimeout(() => {
            onHide();
            setLoading(false);
          }, 1300);
        } else {
          toastShow(toastRef, "error", "Error", resultado[0]?.MENSAJE);
        }
      }
    }
  };

  const onHide = () => {
    setRutaDialog(false);
    resetForm();
    setShow(false);
  };

  useEffect(() => {
    if (rutaDialog) {
      getValoresIniciales();
    }
  }, [rutaDialog]);

  const DialogFooter = (
    <React.Fragment>
      <Button
        label="Cancelar"
        icon="pi pi-times"
        className="p-button-text"
        onClick={onHide}
      />
      <Button
        label="Guardar"
        icon="pi pi-check"
        className="p-button-text"
        onClick={() => {
          agregarRuta();
        }}
        loading={loading}
      />
    </React.Fragment>
  );

  const dialogTitle = modo === "Crear" ? "Agregar Router" : "Editar Router";

  return (
    <div>
      <ConfirmDialog />
      <Dialog
        visible={rutaDialog}
        modal
        className="modal__usuarios"
        footer={DialogFooter}
        onHide={onHide}
        header={dialogTitle}
      >
        <div id="Dialog">
          <Loader loading={loading} querySelector={"#Dialog"} />
          <div style={{ width: "100", margin: "auto" }}>
            {/* <div className="d-flex align-items-center">
              <h2 className="me-3">{dialogTitle}</h2>
            </div> */}
            <Toast ref={toastRef} />

            <div className="modal__input-contenedor gap-2">
              <div className="field col-4">
                <span className="p-float-label">
                  <InputText
                    name="IP"
                    value={values.IP}
                    onChange={handleInputChange}
                    style={{ width: "100%" }}
                    labelStyle={{
                      color: "gray",
                      textShadow: "0px 0px 1px white",
                    }}
                    className={error.IP ? "p-invalid" : ""}
                  />
                  <label htmlFor="IP">IP</label>
                </span>
              </div>

              <div className="field col-4">
                <span className="p-float-label">
                  <InputText
                    name="SSID"
                    value={values.SSID}
                    onChange={handleInputChange}
                    style={{ width: "100%" }}
                    useGrouping={false}
                    className={error.SSID ? "p-invalid" : ""}
                  />
                  <label htmlFor="SSID">SSID</label>
                </span>
              </div>

              <div className="field col-4">
                <span className="p-float-label">
                  <InputText
                    name="ClaveSSID"
                    value={values.ClaveSSID}
                    onChange={handleInputChange}
                    style={{ width: "100%" }}
                    useGrouping={false}
                    className={error.ClaveSSID ? "p-invalid" : ""}
                  />
                  <label htmlFor="ClaveSSID">Clave SSID</label>
                </span>
              </div>
            </div>

            <div className="modal__input-contenedor gap-2">
              <div className="field col-4">
                <span className="p-float-label">
                  <InputText
                    name="ClaveRouter"
                    value={values.ClaveRouter}
                    onChange={handleInputChange}
                    style={{ width: "100%" }}
                    labelStyle={{
                      color: "gray",
                      textShadow: "0px 0px 1px white",
                    }}
                    className={error.ClaveRouter ? "p-invalid" : ""}
                  />
                  <label htmlFor="ClaveRouter">Clave Router</label>
                </span>
              </div>

              <div className="field col-4">
                <span className="p-float-label">
                  <AutoCompleteDropdown
                    name={"Marcas"}
                    value={values.Marcas}
                    items={marcas}
                    field={"Marca"}
                    label={"Marca"}
                    handleInputChange={handleInputChange}
                    labelStyle={{
                      color: "gray",
                      textShadow: "0px 0px 1px white",
                    }}
                    className={error.IdMarca ? "p-invalid" : ""}
                  />
                </span>
              </div>

              <div className="field col-4">
                <span className="p-float-label">
                  <InputText
                    name="Modelo"
                    value={values.Modelo}
                    onChange={handleInputChange}
                    style={{ width: "100%" }}
                    useGrouping={false}
                    className={error.Modelo ? "p-invalid" : ""}
                  />
                  <label htmlFor="Modelo">Modelo</label>
                </span>
              </div>
            </div>

            <div className="modal__input-contenedor gap-2">
              <div className="field col-4">
                <span className="p-float-label">
                  <InputText
                    name="Serie"
                    value={values.Serie}
                    onChange={handleInputChange}
                    style={{ width: "100%" }}
                    labelStyle={{
                      color: "gray",
                      textShadow: "0px 0px 1px white",
                    }}
                    className={error.Serie ? "p-invalid" : ""}
                  />
                  <label htmlFor="Serie">Serie</label>
                </span>
              </div>

              <div className="field col-4">
                <span className="p-float-label">
                  <AutoCompleteDropdown
                    name={"Areas"}
                    value={values.Areas}
                    items={areas}
                    field={"Area"}
                    label={"Area"}
                    handleInputChange={handleInputChange}
                    labelStyle={{
                      color: "gray",
                      textShadow: "0px 0px 1px white",
                    }}
                    className={error.IdArea ? "p-invalid" : ""}
                  />
                </span>
              </div>

              <div className="field col-4">
                <span className="p-float-label">
                  <AutoCompleteDropdown
                    name={"Estados"}
                    value={values.Estados}
                    items={estados}
                    field={"StatusName"}
                    label={"Estado"}
                    handleInputChange={handleInputChange}
                    labelStyle={{
                      color: "gray",
                      textShadow: "0px 0px 1px white",
                    }}
                    className={error.IdStatus ? "p-invalid" : ""}
                  />
                </span>
              </div>
            </div>

            <div className="modal__input-contenedor gap-2">
              <div className="field col-4">
                <span className="p-float-label">
                  <InputTextarea
                    name="Ubicacion"
                    value={values.Ubicacion}
                    onChange={handleInputChange}
                    style={{ width: "100%" }}
                    labelStyle={{
                      color: "gray",
                      textShadow: "0px 0px 1px white",
                    }}
                    className={error.Ubicacion ? "p-invalid" : ""}
                  />
                  <label htmlFor="Ubicacion">Ubicación</label>
                </span>
              </div>
            </div>
          </div>
        </div>
      </Dialog>
    </div>
  );
};

export default RutasCRUD;
